import React from "react";
import getClassNameFactory from "../../utilities/classNames";
import Eyebrow from "../../elements/Eyebrow";
import { Link } from "../../elements";
import { LinkTypes } from "../../elements/Link";
export var SaffronCard = function SaffronCard(_ref) {
  var eyebrow = _ref.eyebrow,
      heading = _ref.heading,
      description = _ref.description,
      link = _ref.link,
      linkText = _ref.linkText,
      newTab = _ref.newTab;
  var getClassName = getClassNameFactory(SaffronCard.displayName);
  return /*#__PURE__*/React.createElement("div", {
    className: getClassName()
  }, /*#__PURE__*/React.createElement("div", {
    className: getClassName({
      descendantName: "content"
    })
  }, eyebrow ? /*#__PURE__*/React.createElement("div", {
    className: getClassName({
      descendantName: "eyebrow"
    })
  }, /*#__PURE__*/React.createElement(Eyebrow, {
    text: eyebrow
  })) : null, /*#__PURE__*/React.createElement("div", {
    className: getClassName({
      descendantName: "heading"
    }),
    role: "heading",
    "aria-level": 2
  }, heading), description ? /*#__PURE__*/React.createElement("div", {
    className: getClassName({
      descendantName: "body"
    })
  }, /*#__PURE__*/React.createElement("div", {
    className: getClassName({
      descendantName: "description"
    }),
    dangerouslySetInnerHTML: {
      __html: description
    }
  })) : null, /*#__PURE__*/React.createElement("div", {
    className: getClassName({
      descendantName: "footer"
    })
  }, /*#__PURE__*/React.createElement(Link, {
    ariaLabel: newTab ? "".concat(linkText, " (opens in a new tab)") : linkText,
    href: link,
    iconRight: newTab,
    newWindow: newTab,
    type: newTab ? LinkTypes.PRIMARY : LinkTypes.INLINE
  }, linkText))));
};
SaffronCard.displayName = "SaffronCard";